import React from 'react';

import Footer from 'components/Footer';
import MaxWidthContainer from 'components/MaxWidthContainer';
import Menubar from 'components/Menubar';
import MobileTabBar from 'components/MobileTabBar';
import { useAppLaunch } from 'contexts/AppLaunch';
const { useState } = React;
const RefundPolicy = (props) => {
  const { notifications } = useAppLaunch();
  const items = [
    'All redeemed products are non-refundable and non-exchangeable once confirmed.',
    'Exchange refund will only be accepted if the product has a quality issue that significantly affects normal usage.',
    'In such cases, we will arrange an exchange for the same item or a product of equivalent value.',
    'The Company reserves the right of final decision.',
  ];

  return (
    <div>
      <main>
        <Menubar
          props={{
            homeExtend: false,
            sourceUI: 'Ranking',
          }}
        />
        <div
          className={
            'globals-centerContentsMargin relative' +
            (notifications.length > 0 ? ' withNoti' : '')
          }
          //   style={{ backgroundImage: 'url(/images/bg-ranking.png)' }}
        >
          <div
            className="h-[130px] w-full lg:h-[136px]"
            style={{
              background:
                'linear-gradient(91deg, #FFF4E7 40.8%, #FFEAEA 100.11%)',
            }}
          >
            <MaxWidthContainer className="flex h-full items-center px-4 lg:px-20">
              <p className="text-[30px] font-bold lg:text-[48px]">
                Refund & Exchange Policy
              </p>
            </MaxWidthContainer>
          </div>
          <MaxWidthContainer className="mb-12 mt-6 min-h-screen px-4 lg:mb-24 lg:mt-12">
            <div className="flex flex-col gap-y-9 lg:gap-y-12">
              <ol className="list-none space-y-2">
                {items.map((item, index) => (
                  <li key={index} className="flex items-start">
                    <span className="mr-2 min-w-[20px]">{index + 1}.</span>
                    <span className="flex-1">{item}</span>
                  </li>
                ))}
              </ol>
            </div>
          </MaxWidthContainer>
        </div>
        <Footer />

        <MobileTabBar props={{}} />
      </main>
    </div>
  );
};

export default RefundPolicy;
